export default "<extent>\n  <xmin>{{mce_xmin}}</xmin>\n  <ymin>{{mce_ymin}}</ymin>\n  <xmax>{{mce_xmax}}</xmax>\n  <ymax>{{mce_ymax}}</ymax>\n</extent>";